<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <a-row type="flex">
          <a-col flex="auto">
            <h6 class="mb-5"><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>IC Vehicle Booking System</h6>
            <p class="mb-5">please click the create booking button.</p>
          </a-col>
          <a-col flex="100px" class="">
            <a-button @click="toCreateBooking" type="primary">
              <a-icon class="mr-2" type="pushpin" />Create Booking
            </a-button>
          </a-col>
        </a-row>
      </template>
      <div v-if="isLoaded" class="div-isLoaded">
        <a-spin />
      </div>
      <span v-else>
        <div v-if="dataListVehicle.length != 0">
          <a-list size="large" :pagination="pagination" :data-source="dataListVehicle">
            <div slot="footer">Vehicle Booking <b>{{ dataListVehicle.length }}</b> List</div>
            <a-list-item class="mt-20" slot="renderItem" slot-scope="query, index">
              <a-list-item-meta>
                <div slot="title">
                  <a-row type="flex">
                    <a-col flex="auto">
                      <h5 class="mb-0">No : {{ query.id }}</h5>
                    </a-col>
                    <a-col flex="100px" class="text-right">
                      <div v-if="query.status === 'wait'">
                        <a @click="showDeleteConfirm(query)"><a-icon :style="{ color: 'red', fontSize: '20px' }" type="delete"
                            theme="filled" /></a>
                      </div>
                      
                    </a-col>
                  </a-row>
                </div>
                <div class="mt-10" slot="description" style="padding: 10px;border-radius: 2%;background-color: #F6F4EB;">
                  <a-descriptions :column="1">
                    <a-descriptions-item label="Reason">
                      {{ query.reason_detail.eng_detail }}
                    </a-descriptions-item>
                    <a-descriptions-item label="Destination">
                      {{ query.destination }}
                    </a-descriptions-item>
                    <a-descriptions-item label="Date">
                      <p class="mt-5 mb-5">
                        {{ moment(query.use_start).format("DD / MM / YYYY , HH:mm:ss") }}
                        -
                        {{ moment(query.use_end).format("DD / MM / YYYY , HH:mm:ss") }}
                      </p>
                    </a-descriptions-item>
                    <a-descriptions-item label="Status">
                      <a-tag :color="query.status === 'wait'
                        ? '#ffc71e'
                        : (query.status === 'approve'
                          ? '#4C6793'
                          : (query.status === 'success' ? '#87d068' : 'red'))
                        ">
                        {{ query.status }}
                      </a-tag>
                    </a-descriptions-item>
                    <a-descriptions-item v-if="['reject', 'cancel'].includes(query.status)" label="Reason of Reject">
                      {{ query.reason_of_cancel }}
                    </a-descriptions-item>
                    <a-descriptions-item v-if="['approve', 'success'].includes(query.status)" label="Driver">
                      <a-list class="">
                        <a-list-item>
                          <a-list-item-meta>
                            <p class="mt-0 mb-0" slot="title">{{ `${query.driver_detail.driver_detail.name} ${query.driver_detail.driver_detail.surname}` }}</p>
                            <a-avatar :size="50" shape="square" slot="avatar"
                              :src="query.driver_detail.driver_detail.img" />
                            <span slot="description" >
                              <p class="mt-0 mb-0">{{ query.driver_detail.driver_detail.email }}</p>
                              <hr>
                              <p class="mt-0 mb-0"><strong>Office Phone :</strong> {{ query.driver_detail.driver_detail.telephone }}</p>
                              <p class="mt-0 mb-0"><strong>Phone :</strong> {{ query.driver_detail.tel }}</p>
                              <hr>
                              <p class="mt-0 mb-0"><strong>Car :</strong> {{ query.car_detail.code }}</p>
                            </span>
                          </a-list-item-meta>
                        </a-list-item>
                      </a-list>
                    </a-descriptions-item>
                  </a-descriptions>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
        <div v-else>
          <a-empty><span slot="description">
              No Vehicle Booking .
              <a @click="toCreateBooking">please click the create booking button</a>
            </span></a-empty>
        </div>
      </span>

    </a-card>
    <!-- dialog -->
    <a-modal v-model="visible" title="Confirm Delete !" ok-text="Delete" ok-type="danger" cancel-text="Close"
      @ok="delBookCarRequest(objData.id)">
      
      <div v-if="visible">
        <small>Reason</small>
        <p class="mt-5 mb-10">
          <strong>{{ objData.reason_detail.eng_detail }}</strong>
        </p>
        <small>Destination</small>
        <p class="mt-5 mb-10">{{ objData.destination }}</p>
        <small>Date</small>
        <p class="mt-5 mb-5">
          Start :
          {{ moment(objData.use_start).format("DD / MM / YYYY , HH:mm:ss") }}
        </p>
        <p class="mt-5 mb-10">
          End :
          {{ moment(objData.use_end).format("DD / MM / YYYY , HH:mm:ss") }}
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "Book Detail",
    dataIndex: "reason_detail",
    scopedSlots: { customRender: "reason_detail" },
  },
  {
    title: "Remark",
    dataIndex: "remark",
    className: "",
    scopedSlots: { customRender: "remark" },
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "text-center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "Action",
    dataIndex: "action",
    className: "text-center",
    scopedSlots: { customRender: "action" },
  },
];
const dataListVehicle = [];
import pdfprint from './pdfprint.vue';
export default {
  components:{
    pdfprint
  },
  data() {
    return {
      columns,
      dataListVehicle,
      isLoaded: false,
      visible: false,
      objData: {},
      perPage: 3,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
      // pagination
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        align: 'start',
        position: 'top',

      },
    };
  },
  mounted() {
    this.getVehicleList();
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/booking/",
        })
        .catch((err) => { });
    },
    onChangePage(currentPage) {
      this.currentPage = currentPage;
      this.offset = Number.parseInt(currentPage - 1) * Number.parseInt(this.perPage);
      this.getListData();
    },
    toCreateBooking() {
      this.$router
        .push({
          path: "vehicle/form",
        })
        .catch((err) => { });
    },
    async getVehicleList() {
      this.isLoaded = true;
      this.dataListVehicle = []
      try {
        const res = await this.$http.get("/vehicle/booking/?limit=" + this.perPage + "&offset=" + this.offset);
        if (res.status === 200) {
          this.dataListVehicle = res.data
          this.countObjData = res.data.count
          this.dataListVehicle.sort((a, b) => {
            return b.id - a.id;
          });
          this.isLoaded = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.isLoaded = false;
        this.dataListVehicle = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /vehicle/booking/`,
        });
      }
    },
    showDeleteConfirm(obj) {
      this.objData = Object.assign({}, obj);
      this.visible = true;
    },
    async delBookCarRequest(id) {
      try {
        const res = await this.$http.delete(`/vehicle/booking/${id}/remove/`);
        if (res.status === 200) {
          this.getVehicleList();
          this.visible = false;
          this.objData = {};
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) { }
    },
  },
};
</script>
<style>
.div-isLoaded {
  text-align: center;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}
</style>